import { render, staticRenderFns } from "./RowContextMenu.vue?vue&type=template&id=c20e01da&"
import script from "./RowContextMenu.vue?vue&type=script&lang=js&"
export * from "./RowContextMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports